import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errorMessage, fieldErrors } from "@/lib/api";
import { useAuth, homeForRole } from "@/context/AuthContext";
import { policyError } from "@/lib/passwordPolicy";
import { MSG } from "@/lib/validators";
import { Notice } from "@/components/form/FormFeedback";
import { PasswordStrength } from "@/components/form/PasswordStrength";
import { usePageTitle } from "@/components/layout/AppLayout";
import { AuthCard, TextInput } from "@/pages/Login";

const SAME = "Scegli una password diversa da quella temporanea";

export default function ChangeTempPassword() {
    usePageTitle("Scegli una nuova password");
    const { user, setUser, logout } = useAuth();
    const navigate = useNavigate();
    const [v, setV] = useState({ current_password: "", password: "", password_confirm: "" });
    const [errors, setErrors] = useState({});
    const [msg, setMsg] = useState("");
    const [busy, setBusy] = useState(false);
    const set = (k) => (e) => setV({ ...v, [k]: e.target.value });
    const submit = async (e) => {
        e.preventDefault();
        const errs = {};
        if (!v.current_password) errs.current_password = MSG.required;
        if (!v.password) errs.password = MSG.required;
        else if (v.password === v.current_password) errs.password = SAME;
        else if (policyError(v.password, user.email)) errs.password = policyError(v.password, user.email);
        if (!v.password_confirm) errs.password_confirm = MSG.required;
        else if (v.password_confirm !== v.password) errs.password_confirm = MSG.passwordMatch;
        setErrors(errs);
        if (Object.keys(errs).length) { document.getElementById(`forced-${Object.keys(errs)[0].replace("_", "-")}`)?.focus(); return; }
        setBusy(true);
        try {
            const { data } = await api.post("/auth/change-temp-password", v);
            setUser(data.user);
            navigate(homeForRole(data.user.role), { replace: true });
        } catch (err) {
            const f = fieldErrors(err);
            setErrors(f || {});
            if (!f) setMsg(errorMessage(err));
        } finally {
            setBusy(false);
        }
    };
    return (
        <AuthCard title="Scegli una nuova password" intro="Hai effettuato l'accesso con una password temporanea. Per continuare scegline una nuova: le altre sessioni aperte verranno chiuse.">
            <form noValidate onSubmit={submit} className="space-y-5" data-testid="forced-change-form">
                <TextInput id="forced-current-password" label="Password temporanea" type="password" autoComplete="current-password" value={v.current_password} onChange={set("current_password")} error={errors.current_password} />
                <div>
                    <TextInput id="forced-password" label="Nuova password" type="password" autoComplete="new-password" value={v.password} onChange={set("password")} error={errors.password} aria-describedby={`forced-password-strength${errors.password ? " forced-password-error" : ""}`} />
                    <PasswordStrength id="forced-password-strength" password={v.password} email={user.email} />
                </div>
                <TextInput id="forced-password-confirm" label="Conferma nuova password" type="password" autoComplete="new-password" value={v.password_confirm} onChange={set("password_confirm")} error={errors.password_confirm} />
                {msg && <Notice kind="error" role="alert" testId="forced-change-message">{msg}</Notice>}
                <button type="submit" className="btn-primary w-full" disabled={busy} data-testid="forced-change-submit">Salva la nuova password</button>
                <button type="button" className="btn-tertiary w-full" onClick={logout} data-testid="forced-change-logout">Esci</button>
            </form>
        </AuthCard>
    );
}
